// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__2_QXl","Open":"SideDrawer__Open__3axuk","Close":"SideDrawer__Close__17bW1","Logo":"SideDrawer__Logo__39zdd"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 311
// module chunks = 0